import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const clientService = {
  getOptions:() => ApiClient.get('clients/create_options'),
  sendMassMessage:(data:any) => ApiClient.post('clients/send_mass_message', data),
  getUsers:(queries:QueriesApi) => ApiClient.get('users',{
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
      is_superuser: queries.is_superuser,
    }
  }),
  getUsersById:(id:string) => ApiClient.get(`users/${id}`),
  getUserPermissions:(id:string) => ApiClient.get(`permissionsset/user_permissions?id=${id}`),
  impersonateUser:(id:string) => ApiClient.post(`users/${id}/impersonate`),
  getUserClients:(id:string) => ApiClient.get(`users/${id}/get_clients`),
  deleteUser:(id:string|number) => ApiClient.delete(`users/${id}`),
  createUser:(data:any) => ApiClient.post('users', data),
  editUser:(data:any) => ApiClient.put(`users/${data?.id}`, data),
  getUserGroups:(queries:QueriesApi) => ApiClient.get('usergroups',{
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
    }
  }),
  getUserGroup:(id:string) => ApiClient.get(`usergroups/${id}`),
  deleteUserGroup:(id:string) => ApiClient.delete(`usergroups/${id}`),
  createUserGroup:(data:any) => ApiClient.post('usergroups', data),
  editUserGroup:(data:any) => ApiClient.put(`usergroups/${data?.id}`, data),

  getUserRoles:(queries:QueriesApi) => ApiClient.get('roles',{
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
    }
  }),
  getUserRole:(id:string) => ApiClient.get(`roles/${id}`),
  getRolePossibleParents:(params: Record<string, any>) =>
    ApiClient.get('roles/get-possible-parents', {
      params,
    }),
  deleteUserRole:(id:string|number) => ApiClient.delete(`roles/${id}`),
  createUserRole:(data:any) => ApiClient.post('roles', data),
  editUserRole:(data:any) => ApiClient.put(`roles/${data?.id}`, data),
  setRolePublic:(id:string|number) => ApiClient.post(`roles/${id}/set-public`),
  setRolePrivate:(id:string|number) => ApiClient.post(`roles/${id}/clear-public`),

  getClientGroups:(queries:QueriesApi) => ApiClient.get('clientgroups',{
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
    }
  }),
  getClientGroup:(id:string) => ApiClient.get(`clientgroups/${id}`),
  deleteClientGroup:(id:string) => ApiClient.delete(`clientgroups/${id}`),
  createClientGroup:(data:any) => ApiClient.post('clientgroups', data),
  editClientGroup:(data:any) => ApiClient.put(`clientgroups/${data?.id}`, data),
  getCloudSummary:(id:any) => ApiClient.get(`clients/${id}/get_cloud_summary`),
  getEmailLogs:(queries:QueriesApi) => ApiClient.get('logger/email-message-log',{
    params:{
      page: queries.page,
      page_size: queries.pageSize,
      ordering: queries.ordering,
      client: queries.client
    }
  }),
  getClientLogs:(queries:QueriesApi) => ApiClient.get('activitylog',{
    params:{
      page: queries.page,
      page_size: queries.pageSize,
      ordering: queries.ordering,
      search: queries.client
    }
  }),
  changeClientCredit:(id:string, data:any) => ApiClient.post(`clients/${id}/change_credit`, data),
  changeClientConfiguration:(id:string, data:any) => ApiClient.post(`clients/${id}/change_configuration`, data),
  updateClientUsage:(id:string) => ApiClient.post(`clients/${id}/update_usage`, {}),
  createClient:(data:any) => ApiClient.post('clients', data),
  sendSms:(data:any) => ApiClient.post('tfa/send_code/', data),
  reSendSms:(data:any) => ApiClient.post('tfa/resend_code/', data),
  confirmEmail:(code:string) => ApiClient.post('confirm-email/', {token:code}),
  getClient:(id:string) => ApiClient.get(`clients/${id}`),
  getClientList:(queries:QueriesApi) => {
    return ApiClient.get('clients', {
      params:{
        page: queries.page,
        page_size: queries.pageSize,
        ordering: queries.ordering,
        search: queries.search,
        filtering: queries.filtering
      }
    })
  },
  // Get clients with enabled OpenStack projects (for staff creating resources)
  getAll:(queries:QueriesApi) => {
    return ApiClient.get('clients', {
      params:{
        page: queries.page || 1,
        page_size: queries.page_size || queries.pageSize || 100,
        ordering: queries.ordering,
        search: queries.search,
        has_enabled_project: queries.has_enabled_project
      }
    })
  },
  getClientUsers:(id:string, pageSize:any=20, ordering:any='-date_created') => ApiClient.get(`clients/${id}/get_users?page_size=${pageSize}&ordering=${ordering}`),
  inviteUserToClient:(id?:string, data?:any) => ApiClient.post(`clients/${id}/send_invitation`, data),
  getAvailableRoles:(id?:string) => ApiClient.get(`clients/${id}/get_available_roles`),
  getUserNotificationSettings:(id?:string) => ApiClient.get(`notifications/get_notifications_settings`),
  canDissociate:(id:string) => ApiClient.get(`clients/${id}/can_dissociate_as_owner`),
  dissociateFromClient:(id?:string) => ApiClient.post(`clients/${id}/dissociate_from_client`, {}),
  updateClient:(id?:string, data?:any) => ApiClient.put(`clients/${id}`, data),
  editUserNotifications:(id?:string, data?:any) => ApiClient.post(`clients/${id}/set_user_notifications_settings`, data),
  getUserNotifications:(client?:any, user?:any) => ApiClient.get(`clients/${client}/get_user_notifications_settings?user_id=${user}`),
  updateUserRoles:(id?:string, data?:any) => ApiClient.post(`clients/${id}/update_roles`, data),
  dissociateUser:(id?:string, data?:any) => ApiClient.post(`clients/${id}/dissociate_user`, data),

  inviteUserCustom:(data:Object) => ApiClient.post(`invites/`, data),
  addUserToClientCustom:(data:Object) => ApiClient.post(`invites/add_user_to_client/`,data),
  deleteUserFromClientNotInvited:(invite_id:any) => ApiClient.delete(`invites/${invite_id}`),

  // Associate existing user with client
  associateUser:(clientId:string, userId:string, roles:number[]) => ApiClient.post(`clients/${clientId}/associate_user`, {
    id: clientId,
    user_id: userId,
    roles: roles
  }),

  // Dissociate client from user (user-side)
  dissociateClientFromUser:(userId:string, clientId:string) => ApiClient.post(`users/${userId}/dissociate_client`, {
    id: userId,
    client_id: clientId
  }),

  // Associate client to user (user-side)
  associateClientToUser:(userId:string, clientId:string, roles:number[]) => ApiClient.post(`users/${userId}/associate_client`, {
    id: userId,
    client_id: clientId,
    roles: roles
  }),

  // Get clients for association with user (not already associated)
  getClientsForAssociation:(queries:QueriesApi) => ApiClient.get('clients', {
    params:{
      page: queries.page || 1,
      page_size: queries.page_size || queries.pageSize || 100,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering
    }
  }),

  // Get users that can be associated with client (not already associated)
  getUsersForAssociation:(queries:QueriesApi) => ApiClient.get('users', {
    params:{
      page: queries.page || 1,
      page_size: queries.page_size || queries.pageSize || 100,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering // e.g., clients__id__ne:{clientId}+is_staff:false+is_active:true
    }
  }),
}

export default clientService
